import './App.css';
import Form from './Form';
import Questions from './Questions';
import { useState } from 'react';
import { Navbar, NavItem, Container, Col } from 'reactstrap';

function App() {
  let [formComplete, updateFormComplete] = useState(false);
  let [streak, updateStreak] = useState(0);

  function streakGain() {
    updateStreak(streak + 1);
  }

  function streakRevert() {
    updateStreak(0);
  }

  function backHome() {
    updateFormComplete(false);
  }

  if (!formComplete) {
    return (
      <div className="App">
        <div className='header'>
          <Navbar color='dark' className='nav'>
            <Container>
              <Col xs='12' sm="12" md={{ size: 6, offset: 3 }}>
                <NavItem  onClick={backHome}><h1>QIUZZER</h1></NavItem>
              </Col>
            </Container>
          </Navbar>
        </div>
        <br />
        <div id='container1'>
        </div>
        <div id='container2'>
          <Form updateFormComplete={updateFormComplete} />
        </div>
        <div>
          <h3>Current Streak: {streak}</h3>
        </div>
        <footer>
          Coded by <a href='https://ssiamon05.github.io/portfolio/'>Sam Siamon</a> using React.js, Bootstrap, and the <a href='https://opentdb.com/api_config.php'>Open Trivia Database API</a>
        </footer>
      </div>
    );
  } else {
    return (
      <div className="App">
        <div className="header">
          <Navbar color='dark' className='nav'>
            <Container>
              <Col xs='12' sm="12" md={{ size: 6, offset: 3 }}>
                <NavItem onClick={backHome}><h1>QIUZZER</h1></NavItem>
              </Col>
            </Container>
          </Navbar>
        </div>
        <br />
        <div id='container1'>
        </div>
        <div id='container2'>
          <Questions streakNum={streak} streakGain={streakGain} streakLose={streakRevert} />
        </div>
        <br />
        <div>
          <h3>Current Streak: {streak}</h3>
        </div>
        <footer>
          Coded by <a href='https://ssiamon05.github.io/portfolio/'>Sam Siamon</a> using React.js, Bootstrap, and the <a href='https://opentdb.com/api_config.php'>Open Trivia Database API</a>
        </footer>
      </div>
    );
  }
}

export default App;
